/**
 * Experience API 패키지 URL
 * @type {string}
 */

const packages = {
    holdings: '/holdings',
    services: '/services',
};

/**
 * Experience API 업무구분 URL
 * @type {string}
 */
const sectors = {
    holdings: {
        cards: `${packages.holdings}/cards`,
    },
    services: {
        common: `${packages.services}/common`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    holdings: {
        cards: {
            inquiry: `${sectors.holdings.cards}/inquiry`,
        },
    },

    services: {
        common: {
            card: `${sectors.services.common}/card`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    holdings: {
        cards: {
            inquiry: {
                listHdTransaction: `${details.holdings.cards.inquiry}/listHdTransaction`,
                getHdExpectedPaymentAmount: `${details.holdings.cards.inquiry}/getHdExpectedPaymentAmount`,
                emptyHdExpectedPaymentAmount: `${details.holdings.cards.inquiry}/emptyHdExpectedPaymentAmount`,
                listCard: `${details.holdings.cards.inquiry}/listCard`,
            },
        },
    },

    services: {
        common: {
            card: {
                getJoinInfo: `${details.services.common.card}/getJoinInfo`,
                listCardOrganInfo: `${details.services.common.card}/listCardOrganInfo`,
                listCardManageInfo: `${details.services.common.card}/listCardManageInfo`,
                listCardLoan: `${details.services.common.card}/listCardLoan`,
                listJoinOrganInfo: `${details.services.common.card}/listJoinOrganInfo`,
                getPaymentLastFiveDays: `${details.services.common.card}/getPaymentLastFiveDays`,
                getMostUsedThreeMonth: `${details.services.common.card}/getMostUsedThreeMonth`,
                getMostSpentLastMonth: `${details.services.common.card}/getMostSpentLastMonth`,
                getCardBasicInfo: `${details.services.common.card}/getCardBasicInfo`,
                getCardListData: `${details.services.common.card}/getCardListData`,
            },
        },
    },
};
